<form [formGroup]="form" (submit)="save()" class="grid body" [class.public-holiday]="holiday"
      [class.should-not-work]="!shouldWork"
      [class.editing]="mode === EditModeEnum.CREATE || mode === EditModeEnum.EDIT">
  <div class="justify-content-center">
    @if (canBeEdited && mode === EditModeEnum.SHOW) {
      <i class="fa fa-edit" role="button" (click)="edit()"></i>
    }

    @if (mode === EditModeEnum.CREATE || mode === EditModeEnum.EDIT) {
      <i class="fa fa-floppy-disk" role="button" (click)="save()"></i>
    }
  </div>

  <div>{{ date.toISO() ?? '' | dfnsParseIso | formatInTimeZone: dfnsLocale: 'fullDate' }}</div>

  @if (mode === EditModeEnum.CREATE || mode === EditModeEnum.EDIT) {

    <div class="d-flex flex-column">
      <select class="form-select" [formControl]="form.controls.type">
        @for (option of timeTrackingEntryTypes; track option) {
          <option [value]="option">{{ 'enums.timeTrackingEntryTypeEnum.' + option | translate }}</option>
        }
      </select>
    </div>

    @for (field of timeInputFields; track field.control) {
      @if (requiresTimeInput()) {
        <app-authenticated-time-tracking-overview-edit-date-row-grid-inline-form-group
          [formControl]="form.controls[field.control]"
          [errorMessages]="{
          required: ('authenticated.time_tracking.overview.edit.form.' + field.control + '.validation_messages.required' | translate),
          pattern: ('authenticated.time_tracking.overview.edit.form.' + field.control + '.validation_messages.pattern' | translate),
        }"
        ></app-authenticated-time-tracking-overview-edit-date-row-grid-inline-form-group>
      } @else {
        <div>-</div>
      }
    }

    <div></div>
    <div></div>

    <app-authenticated-time-tracking-overview-edit-date-row-grid-inline-form-group
      [formControl]="form.controls.comment"
    ></app-authenticated-time-tracking-overview-edit-date-row-grid-inline-form-group>

    <div class="justify-content-center">
      @if (canBeEdited && mode === EditModeEnum.EDIT) {
        <i class="fa fa-trash-can" role="button" (click)="delete()"></i>
      }
    </div>

  } @else {
    <div>{{ entry ? ('enums.timeTrackingEntryTypeEnum.' + entry.type | translate) : holiday ? holiday.name : '-' }}</div>
    <div>{{ entry?.start_at ? (entry?.start_at ?? '' | dfnsParseIso | formatInTimeZone: dfnsLocale: 'shortTime') : '-' }}</div>
    <div>{{ entry?.end_at ? (entry?.end_at ?? '' | dfnsParseIso | formatInTimeZone: dfnsLocale: 'shortTime') : '-' }}</div>
    <div>{{ (entry?.break_time ?? 0) > 0 ? (entry!.break_time ?? 0 | formatDuration: 'minutes') : '-' }}</div>
    <div>{{ (entry?.hours ?? 0) > 0 ? ((entry!.hours ?? 0) | formatDuration: 'hours') : '-' }}</div>

    <div
      [class.positive-overtime]="(entry?.overtime_hours ?? 0) > 0"
      [class.negative-overtime]="(entry?.overtime_hours ?? 0) < 0"
    >{{ (entry?.overtime_hours ?? 0) !== 0 ? ((entry!.overtime_hours ?? 0) | formatDuration: 'hours') : '-'}}</div>

    <div>{{ entry?.comment ?? '-' }}</div>
    <div></div>
  }

</form>
